import { ComponentType } from 'react'

import { ContentSectionBlock } from './ContentSectionBlock'
import { ReadMoreBlock } from './ReadMoreBlock'
import { ReferencesBlock } from './ReferencesBlock'
import ImageWithDescriptionBlock from './ImageWithDescriptionBlock'
import CalloutBlock from './CalloutBlock'

export const blockRegistry: Record<string, ComponentType<{ block: any }>> = {
  'content.content-section': ContentSectionBlock,
  'content.references': ReferencesBlock,
  'content.read-more': ReadMoreBlock,
  'content.image-with-description': ImageWithDescriptionBlock,
  'shared.callout': CalloutBlock,
}
